import { initKameleoon, initPhoneKameleoon, toggleKameleoonGoal, askDevisKameleoon } from "./modules/kameleoon-bundle";

document.addEventListener('DOMContentLoaded', () => {

    initLightbox();
    initSteps();
    initDatepicker();
    initOpenClose();
    initCheckbox();
    initKameleoon();
    initPhoneKameleoon();
    askDevisKameleoon();

    // Attach the onchange event listener to the initCheckbox function
    const memberCheckbox = document.querySelector('.step-7 #member');
    if (memberCheckbox) {
        memberCheckbox.addEventListener('change', (event) => initCheckbox(event));
    }
    const howSelect = document.querySelector('.step-7 #how');
    if (howSelect) {
        howSelect.addEventListener('change', () => changeExplanationField());
    }
    const programSelect = document.querySelector('.step-7 #program');
    if (programSelect) {
        programSelect.addEventListener('change', () => changeExplanationField());
    }
    const toggle = document.querySelector('.step-7 #toggle');
    if (toggle) {
        toggle.addEventListener('click', (event) => changeCheckbox(event));
    }
    changeExplanationField();
});

// Fancybox init
function initLightbox() {
    if(window.Fancybox){
        Fancybox.bind('a.lightbox, [data-fancybox]', {
            dragToClose: false
        });
    }
}

// steps init
function initSteps() {
    document.querySelectorAll('.steps-holder').forEach((elem) => {
        new Steps(elem);
    });
}

// open close init
function initOpenClose() {
    const hideClass = 'hide';

    document.querySelectorAll('.cdv-summary').forEach(function(holder) {
        const opener = holder.querySelector('.cdv-summary__opener');
        const slide = holder.querySelector('.cdv-summary__slide');
        const slideContent = holder.querySelector('.cdv-summary__slide-content');

        ResponsiveHelper.addRange({
            '..767': {
                on: () => {
                    holder.classList.add(hideClass);
                    opener.addEventListener('click', toggleCollapse);
                    window.addEventListener('resize', resizeHandler);
                    window.addEventListener('orientationchange', resizeHandler);
                    document.addEventListener('click', hideOnClickOutside);
                }
            },
            '768..': {
                on: () => {
                    holder.classList.remove(hideClass);
                    opener.removeEventListener('click', toggleCollapse);
                    window.removeEventListener('resize', resizeHandler);
                    window.removeEventListener('orientationchange', resizeHandler);
                    document.removeEventListener('click', hideOnClickOutside);
                }
            }
        });

        function hideOnClickOutside(e) {
            const target = e.target.closest('.cdv-summary');

            if (!target) {
                holder.classList.add(hideClass);
            }
        }

        function toggleCollapse(e) {
            e.preventDefault();

            if (holder.classList.contains(hideClass)) {
                holder.classList.remove(hideClass);
            } else {
                holder.classList.add(hideClass);
            }
        }

        function resizeHandler() {
            slide.style.setProperty('--height', slideContent.clientHeight + 'px');
        }

        resizeHandler();

        window.addEventListener('refreshHeight', resizeHandler);
    });
}

// datepicker init
function initDatepicker() {
    const { Calendar } = window.VanillaCalendarPro;
    const url = new URL(window.location.href);
    const dateDepart = url.searchParams.get("depart");
    const dateRetour = url.searchParams.get("retour");

    const getSelectedDates = () => {
        if (dateDepart && dateRetour) {
            return [dateDepart + ':' + dateRetour];
        }
        return [];
    };
    if(document.querySelectorAll(".calendar")){
        document.querySelectorAll(".calendar").forEach((holder) => {
            const options = {
                selectedDates: getSelectedDates(),
                type: 'multiple',
                selectionDatesMode: 'multiple-ranged',
                selectedTheme: 'light',
                enableJumpToSelectedDate: true,
                onClickDate(self, e) {
                    const selected = self.context.selectedDates;
                    const errorEl = document.querySelector('.error-date');

                    if (selected.length >= 2 && selected[0] && selected[1]) { // if you select the same date 2 times there are not defined
                        window.dispatchEvent(new CustomEvent('selectDate', {
                            detail: selected
                        }));
                        errorEl.classList.add('d-none');
                        errorEl.classList.remove('d-block');
                    } else {
                        errorEl.classList.add('d-block');
                        errorEl.classList.remove('d-none');
                        window.dispatchEvent(new CustomEvent('errorSelectDate'));
                    }
                },
                displayMonthsCount: 2,
                jumpMonths: 1,
                disableToday: true,
                displayDatesOutside: false,
                disableDatesPast: true,
                settings: {
                    lang: 'define',
                    range: {
                        disablePast: true
                    },
                    selection: {
                        day: 'multiple-ranged'
                    },
                    visibility: {
                        theme: 'light',
                        daysOutside: false,
                        weekend: false,
                        today: false
                    }
                },
                locale: {
                    months: {
                        long: [
                            'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
                            'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'
                        ],
                        short: [
                            'Janv', 'Fév', 'Mars', 'Avr', 'Mai', 'Juin',
                            'Juil', 'Août', 'Sept', 'Oct', 'Nov', 'Déc'
                        ]
                    },
                    weekdays: {
                        long: [
                            'Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'
                        ],
                        short: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa']
                    }
                },
            };

        const calendar = new Calendar(holder, options);

            window.addEventListener('resetCalendar', () => {
                calendar.update({
                    selectedDates: null
                });

                const flexibleCheckbox = document.querySelector('#flexible');
                if (flexibleCheckbox) flexibleCheckbox.checked = false;
            });

            const unknownBtn = document.querySelector('#flexible-i-dont-know');
            if (unknownBtn) {
                unknownBtn.addEventListener('click', (e) => {
                    e.preventDefault();

                    calendar.update({
                        selectedDates: null
                    });

                    const flexibleCheckbox = document.querySelector('#flexible');
                    if (flexibleCheckbox) flexibleCheckbox.checked = false;

                    const errorEl = document.querySelector('.error-date');
                    if (errorEl) {
                        errorEl.classList.add('d-none');
                        errorEl.classList.remove('d-block');
                    }

                    window.dispatchEvent(new CustomEvent('selectDate', {
                        detail: []
                    }));

                    window.dispatchEvent(new CustomEvent('resetCalendar'));
                });
            }

            // swipe month init
            const calendarElement = document.querySelector('.calendar');
            let startX;

            if (calendarElement) {
                calendarElement.addEventListener('touchstart', (e) => {
                    startX = e.touches[0].clientX;
                });

                calendarElement.addEventListener('touchmove', (e) => {
                    if (!startX) return;

                    let diffX = e.touches[0].clientX - startX;

                    if (diffX > 50) {
                        // Swipe right
                        const prevButton = calendarElement.querySelector('.vc-arrow_prev');
                        if (prevButton && prevButton.style.visibility !== 'hidden') {
                            prevButton.click();
                        }
                        startX = null;
                    } else if (diffX < -50) {
                        // Swipe left
                        const nextButton = calendarElement.querySelector('.vc-arrow_next');
                        if (nextButton) {
                            nextButton.click();
                        }
                        startX = null;
                    }
                });

                calendarElement.addEventListener('touchend', () => {
                    startX = null;
                });
            }


            calendar.init(); // need to be done at the end
    });
    }
}


function initCheckbox(checkboxOrEvent) {
    const checkbox = checkboxOrEvent?.target || checkboxOrEvent || document.getElementById("member");
    const block = document.getElementById("program-block");
    const holder = document.getElementsByClassName("steps-holder");
    const step = document.getElementsByClassName("active-step");

    if(checkbox && block){
        if (checkbox.checked) {
            block.classList.remove('d-none');
        } else {
            block.classList.add('d-none');
        }
        if(holder && step) {
            holder[0].style.height = step[0].offsetHeight + 'px';
        }
    }


}

function changeCheckbox(event) {
    const checkbox = document.getElementById("member");
    if (!checkbox) {
        return;
    }

    const isControlClick = event && (
        event.target.closest('#member') ||
        event.target.closest('label[for="member"]')
    );

    if (event && !isControlClick) {
        checkbox.checked = !checkbox.checked;
    }

    initCheckbox(checkbox);
}

// steps module
class Steps {
    constructor(elem, options) {
        this.options = Object.assign({
            slider: '.steps-container',
            step: '.step-slide',
            btnBack: '.btn-back',
            btnNext: '.btn-next',
            progress: '.progress-bar__indicator',
            activeStepClass: 'active-step',
            activeClass: 'active',
            hiddenClass: 'hidden',
            disabledClass: 'disabled',
            animateInClass: 'animate-in',
            animateOutClass: 'animate-out',
            animSpeed: 600,
            delay: 250
        }, options);

        this.holder = elem;

        this.findElements();
        this.attachEvents();
       // this.initListenArrow();

        if (this.dateDepart && this.dateRetour) {
            window.dispatchEvent(new CustomEvent('selectDate', {
                detail: [this.dateDepart, this.dateRetour]
            }));
            this.updateCheckedValues(3, 'dates', this.selectedDate);
            this.infoBlock.classList.add(this.options.hiddenClass);
            this.summaryBlock.classList.remove(this.options.hiddenClass);
        }

        if (this.idDestination) {
            if (this.product && !this.product.value) {
                this.product.value = this.idDestination;
            }
            this.addParamUrl(3);
            this.activeStepNumber = 3;
            this.updateCheckedValues(0, 'continent', this.regionField.value);
            if (this.product.dataset.subPaysEntity === '1') {
                if (this.placeField.value) {
                    this.updateCheckedValues(1, 'pays', this.placeField.value);
                }
                if (this.product.dataset.title) {
                    this.updateCheckedValues(1, 'destination', this.product.dataset.title);
                }
            } else {
                this.updateCheckedValues(1, 'pays', this.placeField.value);
            }
            this.infoBlock.classList.add(this.options.hiddenClass);
            this.summaryBlock.classList.remove(this.options.hiddenClass);
            if(this.activeStepNumber === 3){
                this.btnBack[0].classList.add('d-none');
            }
            axios.get(this.buildStepFormUrl({
                product: this.idDestination,
                step: 'second',
                post_id: this.placeField.id,
            }))
                .then((response) => {
                    setTimeout(() => {
                        // show selected region image
                        if (this.placeImage && this.placeField.attributes) {
                            this.placeImage.classList.add(this.options.activeClass);
                            let imageUrl = this.placeField.attributes.data.value;
                            // remove -250x200 from image url which comes from previous step
                            imageUrl = imageUrl.replace('-250x200', '');

                            if (imageUrl) {
                              this.placeImage.setAttribute('src', imageUrl);
                            } else this.placeImage.classList.add('d-none');
                        }

                        const parser = new DOMParser();
                        const doc = parser.parseFromString(response.data, 'text/html');
                        const servicesList = doc.querySelector('.services-list');
                        const reviewBlock = doc.querySelector('.review-block');

                        // add services list
                        if (servicesList) {
                            this.servicesList.innerHTML = servicesList.innerHTML;
                        }

                        this.servicesChoice = this.holder.querySelectorAll('.services-list .cdv-check-list__input');

                        // add review block content
                        if (reviewBlock) {
                            this.selectedReviewsBlock.innerHTML = reviewBlock.innerHTML;
                        }

                        this.selectedReviewsBlock.classList.remove(this.options.hiddenClass);
                        this.summaryContainer.classList.remove("d-none");

                    }, this.options.delay);
                })
                .catch(console.log);
            // Pré-chargement des données produits pour le dataLayer (items)
            this.loadItemsDataLayer();
        } else {
            this.addParamUrl(1);
        }

        toggleKameleoonGoal(this.activeStep);
    }

    findElements() {
        this.slider = this.holder.querySelector(this.options.slider);
        this.steps = this.slider.querySelectorAll(this.options.step);
        this.progress = document.querySelector(this.options.progress);
        this.btnBack = this.holder.querySelectorAll(this.options.btnBack);
        this.btnNext = this.holder.querySelectorAll(this.options.btnNext);
        this.form = this.holder.querySelector('.steps-form');
        this.regionChoice = this.holder.querySelectorAll('.regions-list .grid-list__link');
        this.travelingPlaceBlock = this.holder.querySelector('.traveling-place');
        this.placeImage = document.querySelector('.cdv-visual__selected');
        this.travelersChoice = this.holder.querySelectorAll('.travelers-list .cdv-check-list__input')
        this.travelersChoiceButton = document.getElementsByClassName('button-number')[0]
        this.servicesList = this.holder.querySelector('.services-list');
        this.aside = document.querySelector('.cdv-aside');
        this.infoBlock = this.aside.querySelector('.cdv-aside__block--info');
        this.summaryBlock = this.aside.querySelector('.cdv-aside__block--summary');
        this.summaryList = this.summaryBlock.querySelector('.cdv-summary__list');
        this.summaryContainer = this.summaryBlock.querySelector('.cdv-summary');
        this.selectedReviewsBlock = this.aside.querySelector('.selected-reviews');
        this.defaultReviewBlock = this.aside.querySelector('.default-text');
        this.regionField = this.holder.querySelector('input[name="continent"]');
        this.placeField = this.holder.querySelector('input[name="pays"]');
        this.startDateField = this.holder.querySelector('input[name="start-date"]');
        this.endDateField = this.holder.querySelector('input[name="end-date"]');
        this.product = this.holder.querySelector('input[name="product"]');
        this.btnSubmit = this.holder.querySelector('.btn-submit');
        this.phone = document.querySelector("#phone");
        this.totalSteps = this.steps.length;
        this.selectedDate = null;
        this.prevActiveStep = 0;
        this.activeStep = 0;
        this.activeStepNumber = 1;
        this.isAnimate = false;
        this.currOffset = 0;
        this.stepsData = [];
        this.isMissSecondStep = false;
        this.url = new URL(window.location.href);
        this.idDestination = this.url.searchParams.get("id_destination");
        this.dateDepart = this.url.searchParams.get("depart");
        this.dateRetour = this.url.searchParams.get("retour");
        this.fromStep = this.url.searchParams.get("etape");
        this.customTitle = document.querySelectorAll('h2.step__head-title.step__head-title--custom');
        this.parent = document.referrer;
        this.member = document.getElementById("member");
        this.program = document.getElementById("program");
        this.isBack = false;
        this.iDontKnow = false;
        this.errorMessage = document.querySelector('.error-message-general');
        this.itemsDataLayer = [];
        this.servicesChoice = this.holder.querySelectorAll('.services-list .cdv-check-list__input');
    }

    attachEvents() {
        this.steps.forEach((elem, i) => {
            elem.dataset.stepNumber = i + 1;
            elem.dataset.stepNumberActive = i + 3;
        });

        this.btnBack.forEach((elem) => {
            elem.addEventListener('click', (e) => {
                e.preventDefault();

                this.prevStep();
            });
        });

        this.btnNext.forEach((elem) => {
            elem.addEventListener('click', (e) => {
                e.preventDefault();
                if (this.activeStepNumber === '4') {
                    const category = this.steps[this.activeStep].dataset.category;
                    this.updateCheckedValues(3, category, this.selectedDate);
                } else if (this.activeStepNumber === '5') {
                    const category = this.steps[4].dataset.category;
                    let services = '';

                    if (this.servicesChoice) {
                        this.servicesChoice.forEach((elem, i) => {
                            if (elem.checked) {
                                if (services !== '') {
                                    services += `, ${elem.value}`;
                                } else {
                                    services += elem.value;
                                }
                            }
                        });
                    }
                    if (services !== '') {
                        this.updateCheckedValues(4, 'services', services);
                    }
                }

                this.nextStep();
            });
        });

        if(this.regionChoice){
            // first step handler
            this.regionChoice.forEach((elem) => {
                elem.addEventListener('click', (e) => {
                    e.preventDefault();

                    const target = e.currentTarget;
                    const value = target.dataset.value.trim();

                    if (value.toLowerCase() !== 'je ne sais pas') {
                        this.slider.querySelectorAll(this.options.step)[1].classList.remove(this.options.hiddenClass);
                        this.slider.querySelectorAll(this.options.step)[3].classList.remove(this.options.hiddenClass);
                        this.slider.querySelectorAll(this.options.step)[4].classList.remove(this.options.hiddenClass);
                        this.isMissSecondStep = false;

                        axios.get(target.getAttribute('href'))
                            .then((response) => {
                                this.travelingPlaceBlock.innerHTML = response.data;

                                setTimeout(() => {
                                    this.nextStep();
                                }, this.options.delay);
                            })
                            .catch((error) => {
                                console.log('error', error);
                            });
                    } else {
                        this.steps[1].classList.add(this.options.hiddenClass);
                        this.isMissSecondStep = true;
                        this.iDontKnow = true;
                        // show default review block
                        this.defaultReviewBlock.classList.remove(this.options.hiddenClass);

                        this.nextStep();
                    }
                    this.regionField.value = value;
                    this.updateCheckedValues(0, this.steps[0].dataset.category, this.regionField.value);

                });
            });
        }

        if(this.travelingPlaceBlock){
            // second step handler
            this.travelingPlaceBlock.addEventListener('click', (e) => {
                e.preventDefault();
                const target = e.target.closest('.grid-list__link');
                const category = this.steps[this.activeStep].dataset.category;

                if (target) {
                    let preposition = '';
                    const value = target.dataset.value.trim();
                    const image = target.dataset.image;
                    const review = target.dataset.review;
                    if(target.dataset.preposition){
                        preposition = target.dataset.preposition;
                    }

                    this.updateCheckedValues(this.activeStep, category, value);
                    this.placeField.value = value;

                    // set selected region image
                    if (this.placeImage && image) {
                        this.placeImage.setAttribute('src', image);
                    } else this.placeImage.classList.add('d-none');

                    if(!this.idDestination){
                        this.customTitle.forEach(element => {
                            const text = element.textContent;
                            const index = text.indexOf('voyage');

                            if (index !== -1) {
                                element.innerHTML = text.substring(0, index + 'voyage'.length) + ' <strong>' + preposition + ' ' + this.placeField.value + '</strong>';
                            } else {
                                element.innerHTML += ' <strong>' + preposition + ' ' + this.placeField.value + '</strong>';
                            }
                        });
                    }

                    this.servicesList.innerHTML = '';
                    this.selectedReviewsBlock.innerHTML = '';

                    if (review) {
                        axios.get(review)
                            .then((response) => {
                                setTimeout(() => {
                                    // show selected region image
                                    if (this.placeImage && image) {
                                        this.placeImage.classList.add(this.options.activeClass);
                                    }

                                    const parser = new DOMParser();
                                    const doc = parser.parseFromString(response.data, 'text/html');
                                    const servicesList = doc.querySelector('.services-list');
                                    const reviewBlock = doc.querySelector('.review-block');

                                    // add services list
                                    if (servicesList) {
                                        this.servicesList.innerHTML = servicesList.innerHTML;
                                    }

                                    this.servicesChoice = this.holder.querySelectorAll('.services-list .cdv-check-list__input');

                                    // add review block content
                                    if (reviewBlock) {
                                        this.selectedReviewsBlock.innerHTML = reviewBlock.innerHTML;
                                    }

                                    this.selectedReviewsBlock.classList.remove(this.options.hiddenClass);
                                    this.summaryContainer.classList.remove("d-none");

                                    this.nextStep();
                                }, this.options.delay);
                            })
                            .catch((error) => {
                                console.log(error);
                            });
                    } else {
                        setTimeout(() => {
                            // show selected region image
                            if (this.placeImage && image) {
                                this.placeImage.classList.add(this.options.activeClass);
                            }

                            // show default review block
                            this.defaultReviewBlock.classList.remove(this.options.hiddenClass);

                            this.nextStep();
                        }, this.options.delay);
                    }
                }
            });
        }

        window.addEventListener('errorSelectDate', (event) => {
            if(this.steps[this.activeStep].querySelector(this.options.btnNext)){
                this.steps[this.activeStep].querySelector(this.options.btnNext).classList.add(this.options.disabledClass);
            }
        });

        window.addEventListener('selectDate', (event) => {
            const btnNext = this.steps[this.activeStep].querySelector(this.options.btnNext);

            if(event.detail.length > 0){
                const startDate = event.detail[0];
                let endDate = null;
                if(event.detail.length > 1){
                    endDate = event.detail[event.detail.length - 1];
                }
                this.selectedDate = this.formatDateRange([startDate, endDate]);
                this.startDateField.value = this.formatDate(startDate);
                this.endDateField.value = this.formatDate(endDate);

                if (this.selectedDate) {
                    btnNext.classList.remove(this.options.disabledClass);
                } else {
                    btnNext.classList.add(this.options.disabledClass);
                }
            }
            else {
                this.selectedDate = null;
                this.startDateField.value = null;
                this.endDateField.value = null;
                this.updateCheckedValues(3, 'dates', this.selectedDate);
            }
        });

        // fourth step handler
        this.travelersChoice.forEach((elem) => {
            elem.addEventListener('click', (e) => {
                const target = e.currentTarget;
                const value = target.value.trim();
                if(this.idDestination){
                    const category = this.steps[0].dataset.category;
                    this.updateCheckedValues(2, category, value);
                }
                else {
                    const category = this.steps[2].dataset.category;
                    this.updateCheckedValues(2, category, value);
                }
                this.nextStep();
            });
        });

        this.travelersChoiceButton.addEventListener('click', (e) => {
            const target = document.querySelector('.cdv-check-list__input:checked');
            const value = target.value.trim();

            if(this.idDestination){
                const category = this.steps[0].dataset.category;
                this.updateCheckedValues(2, category, value);
            }
            else {
                const category = this.steps[2].dataset.category;
                this.updateCheckedValues(2, category, value);
            }

            this.nextStep();
        });

        // edit selected option
        this.summaryList.addEventListener('click', (e) => {
            e.preventDefault();
            const target = e.target.closest('.btn-edit');
            this.travelersChoiceButton.classList.remove("d-none");

            if (target) {
                const targetStep = Number(target.dataset.step);
                if(!this.idDestination && (targetStep === 0 || targetStep === 1)){
                    this.summaryContainer.classList.add("d-none");
                    this.infoBlock.classList.remove("hidden");
                }

                const parent = target.closest('li');
                const nextItems = this.nextAll(parent);

                parent.classList.add(this.options.animateOutClass);

                nextItems.forEach((elem) => {
                    elem.classList.add(this.options.animateOutClass);
                });
                this.goToStep(targetStep);

                setTimeout(() => {
                    parent.remove();

                    nextItems.forEach((elem) => {
                        elem.remove();
                    });

                    if(this.idDestination){
                        this.stepsData.splice(Number(targetStep) + 2);
                    }
                    else {
                        this.stepsData.splice(targetStep);
                    }

                }, this.options.animSpeed - 100);
            }
        });

        this.initValidation();
        this.updateProgres();
        this.updateStepPosition();
        this.initBackButton();

        this.onResize = () => {
            this.updateStepPosition();
        }

        window.addEventListener('resize', this.onResize);
        window.addEventListener('orientationchange', this.onResize);

    }

    initBackButton() {
        const button = document.getElementById("btn-back-site");
        const referrer = document.referrer;

        if (button) {
            button.addEventListener('click', function (e) {
                e.preventDefault();
                const fallbackUrl = "/";
                window.location = referrer || fallbackUrl;
            });
        }
    }

    initListenArrow() {
        const self = this;
        window.onpopstate = () => {
            const url = new URL(location);
            const param = url.searchParams.get("etape");
            const etape = parseInt(param.substring(1));
            const destination = url.searchParams.get("id_destination");;
            if(destination){
                self.goToStep(etape - 3);
            }
            else {
                self.goToStep(etape - 1);
            }

        };
    }

    initValidation() {
        this.iti = intlTelInput(this.phone, {
            utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@23.1.1/build/js/utils.js",
            initialCountry: "fr",
            nationalMode: "false",
            separateDialCode: "true",
            autoPlaceholder: "off"
        });

        this.pristine = new Pristine(this.holder.querySelector('.step-7 .cdv-form__row'), {
            classTo: 'cdv-form__group',
            errorClass: 'input-error',
            successClass: 'input-success',
            errorTextParent: 'cdv-form__group',
            errorTextTag: 'div',
            errorTextClass: 'error-message'
        });

        this.pristine.addValidator(this.phone, (value) => {
            return this.iti.isValidNumber();
        }, "Téléphone invalide", 2, true);

        const validationFields = this.holder.querySelectorAll('.step-7 .cdv-form__row [required]');
        const errorPhone = document.querySelector('.error-message-phone');

        this.phone.addEventListener('input', () => {
            if (errorPhone && !errorPhone.classList.contains('d-none')) {
                errorPhone.classList.add('d-none');
            }
        });

        this.btnSubmit.addEventListener('click', (e) => {
            e.preventDefault();

            const params = new FormData(this.form);
            const form = Object.fromEntries(params);

            const acquisitionData = getAcquisitionData();
            form.campaign = acquisitionData.acquisition.sourceCampaign || "Pas de campagne";

            form.fromProduct = !!this.idDestination;

            if (this.idDestination) {
                form.id_destination = this.idDestination;
                if (!form.product) {
                    form.product = this.idDestination;
                }
            }

            form.acquisition = acquisitionData.acquisition;
            form.landing = acquisitionData.landing;
            form.page_avant_demande = acquisitionData.page_avant_demande;
            form.page_demande = acquisitionData.page_demande;
            form.services = '';
            form.member = this.member.checked;

            if (form.program === "Autres") {
                form.program += " : " + form.explanation_program;
            }
            if (form.how === "Autres") {
                form.how += " : " + form.explanation_source;
            }

            let services = this.stepsData.find((el) => el.category === "services");

            if (services) {
                form.services = services.value;
            }

            form.phone = this.iti.getNumber(intlTelInput.utils.numberFormat.E164);

            const data = {
                action: 'send_api_form_data_backup',
                params: JSON.stringify(form)
            };

            const isValid = this.pristine.validate(validationFields) && this.iti.isValidNumber();

            if (!isValid) {
                const loaderInvalid = document.getElementsByClassName("loader-container")[0];
                if (loaderInvalid) loaderInvalid.style.display = 'none';
                this.updateStepPosition();
                return;
            }

            document.getElementsByClassName("loader-container")[0].style.display = 'flex';

            this.pushStepToDataLayer();

            fetch(ajaxurl, {
                method: 'POST',
                body: new URLSearchParams(data),
            })
                .then(response => response.json())
                .then(async body => {
                    try {
                        const loader = document.getElementsByClassName("loader-container")[0];
                        if (loader) loader.style.display = 'none';

                        if (body.success === true) {
                            if (errorPhone && !errorPhone.classList.contains('d-none')) {
                                errorPhone.classList.add('d-none');
                            }

                            const lead = body.data || {};
                            form.backup = lead.backup;

                            this.pushLeadToDataLayer(form.backup, lead.external_tracking);

                            dataLayer.push({
                                event: 'clic',
                                eventCategory: 'devis',
                                eventAction: 'Devis_Validation',
                                eventLabel: form.pays
                            });


                            if (form.subscribe && form.email) {
                                const emailLower = sanitizeEmail(form.email.toLowerCase());
                                const emailHashed = await sha256(emailLower);

                                dataLayer.push({
                                    event: 'newsletter_register',
                                    email_hashed: emailHashed,
                                    location: 'formulaire_devis'
                                });
                            }

                            const secondData = {
                                action: 'send_api_form_data',
                                params: JSON.stringify(form)
                            };

                            fetch(ajaxurl, {
                                method: 'POST',
                                body: new URLSearchParams(secondData),
                            })
                            document.getElementsByClassName("loader-container")[0].style.display = 'none';
                            this.nextStep();
                        } else {
                            if (errorPhone && errorPhone.classList.contains('d-none') && body.data.includes('Phone invalid')) {
                                errorPhone.classList.remove('d-none');
                            }

                            if (this.errorMessage && (errorPhone?.classList.contains('d-none') || !errorPhone)) {
                                this.errorMessage.textContent = body.data || 'Une erreur est survenue.';
                                this.errorMessage.classList.remove('d-none');
                            }
                            document.getElementsByClassName("loader-container")[0].style.display = 'none';
                        }
                    } catch (e) {

                    }
                })
                .catch(error => {

                });

            this.updateStepPosition();
        });

        const refreshSubmitEnabledState = () => {
            this.updateStepPosition();
            const isValid = this.pristine.validate(validationFields);
            if (isValid) {
                this.btnSubmit.classList.remove("disabled");
            } else if (!this.btnSubmit.classList.contains("disabled")) {
                this.btnSubmit.classList.add("disabled");
            }
        };

        validationFields.forEach((elem) => {
            ['keyup', 'change', 'input'].forEach((eventName) => {
                elem.addEventListener(eventName, refreshSubmitEnabledState);
            });
        });
    }

    buildStepFormUrl(params = {}) {
        const ajaxUrl = new URL(this.url);
        ajaxUrl.search = '';
        ajaxUrl.searchParams.set('ajax', 'step_form');
        Object.entries(params).forEach(([key, value]) => {
            if (value != null && value !== '') {
                ajaxUrl.searchParams.set(key, String(value));
            }
        });
        return ajaxUrl.toString();
    }

    addParamUrl(currentStep){
        const urlParams = new URLSearchParams(window.location.search);
        if(currentStep === '8' || currentStep === 8) {
            currentStep = 'confirmation';
        } else {
            currentStep = '0' + currentStep;
        }

        if (urlParams.has('etape')) {
            urlParams.set('etape', currentStep);
        } else {
            urlParams.append('etape', currentStep);
        }

        const newUrl = `${window.location.pathname}?${urlParams.toString()}`;
        window.history.replaceState(null, '', newUrl);
    }

    updateStepsState() {
        const toggleBlocks = () => {
            // hide summary block
            this.summaryBlock.classList.add(this.options.animateOutClass);

            setTimeout(() => {
                this.summaryBlock.classList.add(this.options.hiddenClass);
                this.summaryBlock.classList.remove(this.options.animateOutClass);

                // hide selected review block
                this.selectedReviewsBlock.classList.add(this.options.hiddenClass);
                // hide default review block
                this.defaultReviewBlock.classList.add(this.options.hiddenClass);
            }, this.options.animSpeed);

            // show info block
            this.infoBlock.classList.remove(this.options.hiddenClass);
            this.infoBlock.classList.add(this.options.animateInClass);

            setTimeout(() => {
                this.infoBlock.classList.remove(this.options.animateInClass);
            }, this.options.animSpeed);

            // show default info image
            this.placeImage.classList.remove(this.options.activeClass);
        }
        if (this.activeStepNumber === '1') {
            if (this.prevActiveStep === 1 && this.isMissSecondStep) {
                toggleBlocks();
            }
        } else if (this.activeStepNumber === '2') {
            if (this.prevActiveStep === 2 && !this.isMissSecondStep) {
                toggleBlocks();
            }
        } else if (this.activeStepNumber === '3') {
            if (this.prevActiveStep < this.activeStep) {
                // show summary block
                this.summaryBlock.classList.remove(this.options.hiddenClass);
                this.summaryBlock.classList.add(this.options.animateInClass);

                setTimeout(() => {
                    this.summaryBlock.classList.remove(this.options.animateInClass);
                }, this.options.animSpeed);

                // hide info block
                this.infoBlock.classList.add(this.options.animateOutClass);

                setTimeout(() => {
                    this.infoBlock.classList.add(this.options.hiddenClass);
                    this.infoBlock.classList.remove(this.options.animateOutClass);
                }, this.options.animSpeed);
            }
        } else if (this.activeStepNumber === '8') {
            this.aside.classList.add(this.options.hiddenClass);
        }
    }

    updateCheckedValues(stepNum, category, value, isBackDirection) {
        const stepCategory = this.steps[stepNum].dataset.category;
        let removedIndex = null;
        this.isBack = false;
        // remove selected item from array when go to the previous step
        if (isBackDirection && stepCategory) {
            removedIndex = this.stepsData.findIndex(obj => obj.category === stepCategory);
            this.isBack = true;
            setTimeout(() => {
                if (removedIndex !== -1) {
                    this.stepsData.splice(removedIndex, 1);
                }
            }, this.options.animSpeed);
        }
        if (category) {
            const hasCategory = this.stepsData.some(obj => obj.category === category);
            if (hasCategory) {
                this.stepsData.forEach((obj) => {
                    if (obj.category === category) {
                        obj.value = value;
                    }
                });
            } else {
                this.stepsData.push({
                    step: +stepNum,
                    category,
                    value
                });
            }
        }
        if (stepCategory || category) {
            this.summaryList.innerHTML = '';
            this.stepsData.forEach((elem, i) => {
                const item = document.createElement('li');

                if (i === this.stepsData.length - 1) {
                    if (isBackDirection) {
                        if (removedIndex !== -1) {
                            item.classList.add(this.options.animateOutClass);

                            setTimeout(() => {
                                item.remove();
                            }, this.options.animSpeed - 100);
                        }
                    } else {
                        item.classList.add(this.options.animateInClass);

                        setTimeout(() => {
                            item.classList.remove(this.options.animateInClass);
                        }, this.options.animSpeed);
                    }
                }
                if (!elem.value || elem.value.toLowerCase() === 'je ne sais pas') return;

                if(this.idDestination && elem.step === 2){
                    item.innerHTML = `<span>${elem.value} voyageur(s)</span> <a class="btn-edit" data-step="${elem.step - 2}" href="#">Modifier</a>`;
                }
                else if(this.idDestination && elem.step === 1 && elem.category === 'pays'){
                    item.innerHTML = `<span>${elem.value}</span>`;
                }
                else if(this.idDestination && elem.step === 1 && elem.category === 'destination'){
                    item.innerHTML = `<span>${elem.value}</span>`;
                }
                else if(this.idDestination && elem.step === 1){
                    item.innerHTML = `<span>${this.product.dataset.title}</span>`;
                }
                else if(this.idDestination && elem.step === 0){
                    item.innerHTML = `<span>${elem.value}</span>`;
                }
                else if(this.dateDepart && this.dateRetour && elem.step < 4 && elem.category === 'dates'){
                    item.classList.add('special');
                    item.innerHTML = `<span>${elem.value}</span> <a class="btn-edit d-none" data-step="${elem.step - 2}" href="#">Modifier</a>`;
                }
                else if(elem.step === 4) {
                    let services = '';
                    let serviceChoice = this.holder.querySelectorAll('.services-list .cdv-check-list__input');
                    serviceChoice.forEach((elem, i) => {
                         if (elem.checked) {
                             if (services !== '') {
                                 services += `, ${elem.dataset.title}`;
                             } else {
                                 services += elem.dataset.title;
                             }
                         }
                    });
                    const prevStep = this.steps.length === 6 ? (elem.step - 2) : elem.step;
                    item.innerHTML = `<span>${services}</span> <a class="btn-edit" data-step="${prevStep}" href="#">Modifier</a>`;
                }
                else if(this.idDestination && (!this.dateDepart || !this.dateRetour)){
                    item.innerHTML = `<span>${elem.value}</span> <a class="btn-edit" data-step="${elem.step - 2}" href="#">Modifier</a>`;
                }
                else if(elem.step === 2){
                    item.innerHTML = `<span>${elem.value} voyageur(s)</span> <a class="btn-edit" data-step="${elem.step}" href="#">Modifier</a>`;
                }
                else if(elem.value === ''){
                     item.innerHTML = ``;
                 }
                else {
                    item.innerHTML = `<span>${elem.value}</span> <a class="btn-edit" data-step="${elem.step}" href="#">Modifier</a>`;
                }

                this.summaryList.append(item);
            });
        }
    }

    prevStep() {
        if (this.isAnimate) return;

        this.errorMessage.classList.add('d-none');
        this.prevActiveStep = this.activeStep;
        this.activeStep--;
        const isServicesListEmpty = !this.servicesList || 
            !this.servicesList.innerHTML || 
            this.servicesList.innerHTML.trim() === '' ||
            (this.servicesChoice && this.servicesChoice.length === 0) || 
            !this.servicesChoice;
        
        if (((this.idDestination && this.activeStep === 2)
            || (this.idDestination === null && this.activeStep === 4 && !this.iDontKnow)
            || (this.idDestination === null && this.activeStep === 3 && this.iDontKnow) )
            && isServicesListEmpty
        ) {
            this.activeStep--;
        }

        if (this.activeStep < 0) {
            this.activeStep = 0;
        }

        if ((!this.isMissSecondStep && this.activeStep !== 1) || (this.isMissSecondStep && this.activeStep !== 0)) {
            this.updateCheckedValues(this.activeStep, null, null, true);
        }

        if (this.activeStep === 1) {
            const btnNext = this.steps[this.activeStep].querySelector(this.options.btnNext);
            if (btnNext) {
                const bothDatesFilled = this.startDateField?.value && this.endDateField?.value;
                if (bothDatesFilled) {
                    btnNext.classList.remove(this.options.disabledClass);
                } else {
                    btnNext.classList.add(this.options.disabledClass);
                }
            }
        }

        // Si l'étape des pays a été sautée (cas "Je ne sais pas"), on retourne directement au continent
        if (this.activeStep === 1 && this.isMissSecondStep) {
            this.activeStep = 0;
        }

        this.switchStep();
    }

    nextStep() {
        if (this.isAnimate) return;

        this.prevActiveStep = this.activeStep;

        this.activeStep++;
        // Vérifier si l'étape des services doit être sautée (liste vide ou pas de choix disponibles)
        const isServicesListEmpty = !this.servicesList || 
            !this.servicesList.innerHTML || 
            this.servicesList.innerHTML.trim() === '' ||
            (this.servicesChoice && this.servicesChoice.length === 0) || 
            !this.servicesChoice;
        
        if (((this.idDestination && this.activeStep === 2)
            || (this.idDestination === null && this.activeStep === 4 && !this.iDontKnow)
            || (this.idDestination === null && this.activeStep === 3 && this.iDontKnow) )
            && isServicesListEmpty
        ) {
            this.activeStep++;
        }

        if (this.activeStep > this.itemsLenght - 1) {
            this.activeStep = this.itemsLenght - 1;
        }

        this.switchStep();
    }

    goToStep(num) {
        this.prevActiveStep = this.activeStep;
        this.activeStep = num;
        this.switchStep();
    }

    switchStep() {
        this.isAnimate = true;
        toggleKameleoonGoal(this.activeStep);

        this.steps = [].slice.call(this.slider.querySelectorAll(this.options.step)).filter(step => !step.classList.contains(this.options.hiddenClass));
        this.totalSteps = this.steps.length;
        this.steps.forEach((elem) =>  elem.classList.remove(this.options.activeStepClass));
        const currentStep = this.steps[this.activeStep];
        currentStep.classList.add(this.options.activeStepClass);
        if (this.idDestination){
            this.activeStepNumber = currentStep.dataset.stepNumberActive;
        } else {
            this.activeStepNumber = currentStep.dataset.stepNumber;
        }

        if (this.activeStep === 1) {
            const url = new URL(window.location.href);
            const dateDepart = url.searchParams.get("depart");
            const dateRetour = url.searchParams.get("retour");
            const errorEl = document.querySelector('.error-date');

            if (dateDepart && dateRetour) {
                window.dispatchEvent(new CustomEvent('selectDate', {
                    detail: [dateDepart, dateRetour]
                }));
                errorEl.classList.add('d-none');
                errorEl.classList.remove('d-block');
            }

            if (dateDepart && dateRetour && this.isBack === false){
                this.goToStep(this.activeStep + 1);
            }

            const btnNextDate = this.steps[this.activeStep].querySelector(this.options.btnNext);
            if (btnNextDate && this.startDateField && this.endDateField) {
                const bothDatesFilled = this.startDateField.value && this.endDateField.value;
                if (bothDatesFilled) {
                    btnNextDate.classList.remove(this.options.disabledClass);
                } else {
                    btnNextDate.classList.add(this.options.disabledClass);
                }
            }
        } else if (this.activeStep === 2){
            const item = document.querySelector('.special');
            if (item) {
                const hiddenChild = Array.from(item.children).find(child => child.classList.contains('d-none'));
                if (hiddenChild) {
                    hiddenChild.classList.remove('d-none');
                }
            }
        }

        this.updateStepsState();
        this.updateStepPosition();
        this.updateProgres();
        this.addParamUrl(this.activeStepNumber);

        // Envoi de la progression dans le dataLayer à chaque changement d'étape
        this.pushStepToDataLayer();

        setTimeout(() => {
            this.isAnimate = false;
            window.dispatchEvent(new CustomEvent('refreshHeight'));
        }, this.options.animSpeed);
    }

    updateProgres() {
        if (this.progress) {
            this.progress.style.width = ((+this.activeStep + 1) * 100) / this.totalSteps + '%';
        }
    }

    updateStepPosition() {
        this.currOffset = 0;

        this.steps.forEach((elem, i) => {
            if (this.activeStep > i) {
                this.currOffset += elem.clientHeight;
            }
        });

        this.slider.style.marginTop = -this.currOffset + 'px';
        this.holder.style.height = this.steps[this.activeStep].offsetHeight + 'px';

    }

    nextAll(elem, selector) {
        let siblings = [];

        while (elem = elem.nextElementSibling) {
            if (!selector || elem.matches(selector)) {
                siblings.push(elem);
            }
        }

        return siblings;
    }

    formatDateRange(dates) {
        const getFrenchMonthName = (dateString) => {
            const date = new Date(dateString);
            return date.toLocaleString('fr-FR', { month: 'long' });
        };

        const date1 = new Date(dates[0]);
        const day1 = date1.getDate();
        const month1 = getFrenchMonthName(dates[0]);
        const year1 = date1.getFullYear();

        // Si pas de deuxième date, on affiche seulement la première
        if (!dates[1]) {
            return `${day1} ${month1} ${year1}`;
        }

        const date2 = new Date(dates[1]);
        const day2 = date2.getDate();
        const month2 = getFrenchMonthName(dates[1]);
        const year2 = date2.getFullYear();

        if (month1 === month2 && year1 === year2) {
            return `${day1} - ${day2} ${month1} ${year1}`;
        } else if (year1 === year2) {
            return `${day1} ${month1} - ${day2} ${month2} ${year1}`;
        } else {
            return `${day1} ${month1} ${year1} - ${day2} ${month2} ${year2}`;
        }
    }

    formatDate(date) {
        if (!date || typeof date !== "string") {
            return "";
        }

        const dateParts = date.split("-");
        return `${dateParts[0]}-${dateParts[1]}-${dateParts[2]}`;
    }

    /**
     * Récupère les voyages à partir de l'API pour alimenter les items du dataLayer
     * Basé sur le paramètre d'URL ?id_destination= (un ou plusieurs ids séparés par des virgules)
     */
    loadItemsDataLayer() {
        if (!this.idDestination) {
            return;
        }

        const ids = this.idDestination
            .split(',')
            .map((id) => id.trim())
            .filter((id) => id.length > 0);

        if (!ids.length) {
            return;
        }

        const url = `/wp-json/cdv/v2/voyage?ids=${encodeURIComponent(ids.join(','))}`;

        fetch(url)
            .then((res) => res.json())
            .then((payload) => {
                const voyages = (payload && payload.voyages) ? payload.voyages : [];

                this.itemsDataLayer = voyages.slice(0, 10).map((voyage) => ({
                    item_id: voyage.id,
                    item_name: voyage.title,
                    price: Number(voyage.price_min_pp) || 0,
                    quantity: 1,
                    item_category: voyage.city_name,
                    item_category2: voyage.region_name,
                    item_category3: voyage.country_name,
                    item_category4: voyage.continent_name,
                    city_id: voyage.city_id,
                    region_id: voyage.region_id,
                    country_id: voyage.country_id,
                    continent_id: voyage.continent_id,
                    price_min_pp: Number(voyage.price_min_pp) || 0,
                    price_max_pp: Number(voyage.price_max_pp) || 0,
                    trip_duration_days: voyage.trip_duration_days || 0,
                    trip_duration_nights: voyage.trip_duration_nights || 0,
                    item_brand: "Cercle des Voyages",
                    item_variant: voyage.item_variant || "",
                    theme: voyage.theme || "",
                    advisor_name: voyage.advisor_name || "",
                    itinerary_sample: Array.isArray(voyage.itinerary_sample) ? voyage.itinerary_sample : []
                }));
            })
            .catch((error) => {
                console.error('Erreur lors du chargement des voyages pour le dataLayer :', error);
            });
    }

    pushStepToDataLayer() {
        if (typeof window === 'undefined') {
            return;
        }

        window.dataLayer = window.dataLayer || [];

        const { customerData, ...travelData } = this.getTravelDataLayer();

        window.dataLayer.push({
            event: 'travel_conception',
            ecommerce: {
                ...travelData,
                travel_step: parseFloat(this.activeStepNumber - 1) || null,
                customer_datas: customerData
            },
            _clear: true
        });
    }

    /**
     * Envoi du lead dans le dataLayer, une fois le devis enregistré côté back
     * @param {string|number} leadId ID du post de backup du devis
     * @param {object} externalTracking external_tracking envoyé à Carmen, calculé par le back
     */
    pushLeadToDataLayer(leadId, externalTracking) {
        window.dataLayer = window.dataLayer || [];

        const { customerData, ...travelData } = this.getTravelDataLayer();
        const phone = this.iti ? this.iti.getNumber(intlTelInput.utils.numberFormat.E164) : '';

        window.dataLayer.push({
            event: 'generate_lead',
            lead_id: leadId ? String(leadId) : null,
            ecommerce: {
                ...travelData,
                customer_data: { ...customerData, phone: phone || customerData.phone },
                attribution_data: externalTracking || {}
            },
            _clear: true
        });
    }

    /**
     * Données du voyage en cours de conception, communes aux events dataLayer du formulaire
     */
    getTravelDataLayer() {
        const items = Array.isArray(this.itemsDataLayer) && this.itemsDataLayer.length > 0
            ? this.itemsDataLayer
            : [];

        const value = items.length
            ? (typeof items[0].price_min_pp === 'number' && !isNaN(items[0].price_min_pp)
                ? items[0].price_min_pp
                : 0
            )
            : 0;

        let travelPeople = null;
        if (Array.isArray(this.stepsData) && this.stepsData.length > 0) {
            const peopleStep = this.stepsData.find(
                (el) => el.category === 'travelers'
            );
            if (peopleStep && peopleStep.value) {
                travelPeople = parseFloat(peopleStep.value) || null;
            }
        }

        const travelStartDate = this.startDateField ? (this.startDateField.value || null) : null;
        const travelEndDate = this.endDateField ? (this.endDateField.value || null) : null;

        const flexibleCheckbox = document.querySelector('#flexible');
        const isFlexible = (flexibleCheckbox && flexibleCheckbox.checked) || this.iDontKnow === true;
        const travelDateFlexibility = !!isFlexible;

        let travelPreference = [];
        if (this.servicesChoice && this.servicesChoice.length > 0) {
            this.servicesChoice.forEach((input) => {
                if (input.checked) {
                    const label =
                        (input.dataset && input.dataset.title) ||
                        input.value ||
                        null;
                    if (label) {
                        travelPreference.push(label);
                    }
                }
            });
        }

        const firstNameEl = document.querySelector('input[name="first-name"]');
        const lastNameEl = document.querySelector('input[name="last-name"]');
        const emailEl = document.querySelector('input[name="email"]');
        const phoneEl = document.querySelector('input[name="phone"]');
        const loyaltyEl = document.querySelector('#member');
        const newsletterEl = document.querySelector('input[name="subscribe"]');

        return {
            currency: 'EUR',
            value: value,
            items: items,
            travel_people: travelPeople,
            travel_start_date: travelStartDate,
            travel_end_date: travelEndDate,
            travel_date_flexibility: travelDateFlexibility,
            travel_preference: travelPreference,
            customerData: {
                first_name: firstNameEl ? firstNameEl.value || null : null,
                last_name: lastNameEl ? lastNameEl.value || null : null,
                email: emailEl ? emailEl.value || null : null,
                phone: phoneEl ? phoneEl.value || null : null,
                loyalty_program: loyaltyEl ? !!loyaltyEl.checked : false,
                newsletter: newsletterEl ? !!newsletterEl.checked : false
            }
        };
    }

    makeCallback(name) {
        if (typeof this.options[name] === 'function') {
            var args = Array.prototype.slice.call(arguments);

            args.shift();
            this.options[name].apply(this, args);
        }
    }
}

/*
* Responsive Layout helper
*/
ResponsiveHelper = (function() {
    // init variables
    var handlers = [];
    var prevWinWidth;
    var nativeMatchMedia = false;

    // detect match media support
    if (window.matchMedia) {
        if (window.Window && window.matchMedia === Window.prototype.matchMedia) {
            nativeMatchMedia = true;
        } else if (window.matchMedia.toString().indexOf('native') > -1) {
            nativeMatchMedia = true;
        }
    }

    // prepare resize handler
    function resizeHandler() {
        var winWidth = window.innerWidth;

        if (winWidth !== prevWinWidth) {
            prevWinWidth = winWidth;

            // loop through range groups
            for (var key in handlers) {
                var rangeObject = handlers[key];
                // disable current active area if needed
                for (var property in rangeObject.data) {
                    var item = rangeObject.data[property];

                    if (item.currentActive && !matchRange(item.range[0], item.range[1])) {
                        item.currentActive = false;

                        if (typeof item.disableCallback === 'function') {
                            item.disableCallback();
                        }
                    }
                }

                // enable areas that match current width
                for (var property in rangeObject.data) {
                    var item = rangeObject.data[property];

                    if (!item.currentActive && matchRange(item.range[0], item.range[1])) {
                        // make callback
                        item.currentActive = true;

                        if (typeof item.enableCallback === 'function') {
                            item.enableCallback();
                        }
                    }
                }
            }
        }
    }

    window.addEventListener('load', resizeHandler);
    window.addEventListener('resize', resizeHandler);
    window.addEventListener('orientationchanged', resizeHandler);

    // test range
    function matchRange(r1, r2) {
        var mediaQueryString = '';

        if (r1 > 0) {
            mediaQueryString += '(min-width: ' + r1 + 'px)';
        }

        if (r2 < Infinity) {
            mediaQueryString += (mediaQueryString ? ' and ' : '') + '(max-width: ' + r2 + 'px)';
        }

        return matchQuery(mediaQueryString, r1, r2);
    }

    // media query function
    function matchQuery(query, r1, r2) {
        if (window.matchMedia && nativeMatchMedia) {
            return matchMedia(query).matches;
        } else if (window.styleMedia) {
            return styleMedia.matchMedium(query);
        } else if (window.media) {
            return media.matchMedium(query);
        } else {
            return prevWinWidth >= r1 && prevWinWidth <= r2;
        }
    }

    // range parser
    function parseRange(rangeStr) {
        var rangeData = rangeStr.split('..');
        var x1 = parseInt(rangeData[0], 10) || -Infinity;
        var x2 = parseInt(rangeData[1], 10) || Infinity;

        return [x1, x2].sort(function(a, b) {
            return a - b;
        });
    }

    // export public functions
    return {
        addRange: function(ranges) {
            // parse data and add items to collection
            var result = {
                data: {}
            };

            for (var key in ranges) {
                result.data[key] = {
                    range: parseRange(key),
                    enableCallback: ranges[key].on,
                    disableCallback: ranges[key].off
                };
            }

            handlers.push(result);

            // call resizeHandler to recalculate all events
            prevWinWidth = null;
            resizeHandler();
        }
    };
}());

function changeExplanationField() {

    const selectSource = document.getElementById("how");
    const selectProgram = document.getElementById("program");
    const blockSource = document.getElementById("cdv-form__explanation_source");
    const colExplanationSource = document.getElementById("cdv-form__col_explanation_source");
    const blockProgram = document.getElementById("cdv-form__explanation_program");
    const holder = document.getElementsByClassName("steps-holder");
    const step = document.getElementsByClassName("active-step");

    // Vérification des éléments avant modification (option "Autre" venant des sources)
    if (selectSource && blockSource) {
        const sourceLabel = selectSource.options[selectSource.selectedIndex]?.text?.trim().toLowerCase() ?? '';
        if (sourceLabel === 'autre' || sourceLabel === 'autres') {
            blockSource.classList.remove('d-none');
            if (colExplanationSource) colExplanationSource.classList.remove('d-none');
        } else {
            blockSource.classList.add('d-none');
            if (colExplanationSource) colExplanationSource.classList.add('d-none');
        }

        // Mise à jour de la hauteur du holder si les éléments sont présents
        if (holder.length > 0 && step.length > 0) {
            holder[0].style.height = step[0].offsetHeight + 'px';
        }
    }

    if (selectProgram && blockProgram) {
        if (selectProgram.options[selectProgram.selectedIndex].text === 'Autres') {
            blockProgram.classList.remove('d-none');
        } else {
            blockProgram.classList.add('d-none');
        }

        // Mise à jour de la hauteur du holder si les éléments sont présents
        if (holder.length > 0 && step.length > 0) {
            holder[0].style.height = step[0].offsetHeight + 'px';
        }
    }
}

/**
 * Nettoie un email avant hashage pour éviter les injections indirectes.
 */
function sanitizeEmail(email) {
	return email.replace(/[^\w@.\-+]/g, '');
}

/**
 * Hash SHA-256 asynchrone
 */
async function sha256(str) {
	const encoder = new TextEncoder();
	const data = encoder.encode(str);
	const hash = await crypto.subtle.digest('SHA-256', data);
	return Array.from(new Uint8Array(hash))
		.map(b => b.toString(16).padStart(2, '0'))
		.join('');
}

// Fournie par cdv-common.js ; valeurs vides si le script n'est pas chargé.
function getAcquisitionData() {
    if (typeof window.cdvGetAcquisitionData === 'function') {
        return window.cdvGetAcquisitionData();
    }
    return {
        acquisition: { device: 'c' },
        landing: '',
        page_avant_demande: '',
        page_demande: '',
    };
}
